import React, { useEffect, useState } from "react";

import { BsWhatsapp } from "react-icons/bs";
import { IoChevronDown, IoMenu, IoClose } from "react-icons/io5";
import { MdMail } from "react-icons/md";
import { Link, useLocation } from "react-router-dom"; // useLocation add kiya

const menuItems = [
  { title: "Home", link: "/" },
  {
    title: "About Us",
    subMenu: [
      { title: "About Pioneer", link: "/About" },
      // { title: "Our Story", link: "/OurStory" },
      { title: "Vision & Mission", link: "/Vision" },
      { title: "Our Founder", link: "/Founder" },
      { title: "Manager’s Message", link: "/Manager" },
      { title: "Principal’s Message", link: "/Principal" },
      { title: "Our Branches", link: "/Branches" },
      { title: "Mandatory Disclosure", link: "/MandatoryPublic" },
    ],
  },
  {
    title: "Infrastructure",
    subMenu: [
      // { title: "Class Room", link: "/modern-class-room" },
      { title: "Computer Lab", link: "/advanced-computer-laboratory" },
      { title: "Physics Lab", link: "/advanced-physics-laboratory" },
      { title: "Chemistry Lab", link: "/advanced-chemistry-laboratory" },
      { title: "Biology Lab", link: "/advanced-biology-laboratory" },
      { title: "Maths Lab", link: "/interactive-mathematics-lab" },
      { title: "Library", link: "/rich-quiet-library" },
      // { title: "Activity Room", link: "/creative-activity-room" },
      { title: "AI & Robotics", link: "/ai-robotics-lab" },
      { title: "Music Room", link: "/dedicated-music-room" },
      { title: "Smart Class", link: "/digital-smart-classrooms" },
      { title: "Transportation", link: "/safe-school-transportation" },
      { title: "Safety & Security", link: "/247-safety-cctv-surveillance" },
      { title: "Creative Art & Craft Room", link: "/creative-art-craft-room" },
      { title: "Geography Lab", link: "/geography-lab" },
    ],
  },
  {
    title: "Admission",
    subMenu: [
      { title: "Admission Procedure", link: "/AdmissionProcedure" },
      { title: "Fee Structure", link: "/FeeStructure" },
      { title: "Prospectus", link: "/Prospectus" },
      { title: "Book List", link: "/BookList" },
    ],
  },
  {
    title: "Student",
    subMenu: [
      { title: "Uniform", link: "/Uniform" },
      { title: "Club", link: "/Club" },
      { title: "Student Council", link: "/StudentCouncil" },
      { title: "Testimonials", link: "/Testimonials" },
      { title: "Our Alumni", link: "/OurAlumni" },
      { title: "Transfer Certificate", link: "/TransferCertificate" },
    ],
  },
  // {
  //   title: "Academic",
  //   subMenu: [
  //     { title: "Syllabus", link: "/Syllabus" },
  //     { title: "Book List", link: "/BookList" },
  //   ],
  // },
  {
    title: "Gallery",
    subMenu: [
      { title: "Photo Gallery", link: "/PhotoGallery" },
      { title: "Video Gallery", link: "/VideoGallery" },
      { title: "Media Gallery", link: "/MediaGallery" },
    ],
  },
  {
    title: "Achievements",
    subMenu: [
      { title: "Our Achievements", link: "/OurAchievements" },
      { title: "Toppers X", link: "/ToppersX" },
      { title: "Toppers XII", link: "/ToppersXII" },
    ],
  },
  { title: "Contact Us", link: "/Contact" },
];

const HeaderContent = () => {
  const location = useLocation(); // Track route changes
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  // Sticky header
  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Main Feature: Scroll to top + close mobile menu on every route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Ya "instant" bhi rakh sakte ho agar bilkul instant chahiye
    });

    // Mobile menu aur dropdown band kar do jab page change ho
    setIsMobileMenuOpen(false);
    setOpenDropdownIndex(null);
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      setOpenDropdownIndex(null);
    }
  };

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  // Submenu click pe mobile menu band karne ke liye helper
  const handleSubmenuClick = () => {
    setIsMobileMenuOpen(false);
    setOpenDropdownIndex(null);
  };


  const phoneNumber = '916387355032';
  const message = 'Hello! Quick question.';

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };


  return (
    <header className={`header header-sticky ${isSticky ? "sticky-top" : ""}`}>
      {/* Topbar */}
      <div className="topbar bg-dark py-2 d-none d-lg-flex">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="d-none d-lg-flex align-items-center text-center justify-content-between">
                <div className="mr-3 d-inline-block">
                  <a className="text-white d-flex gap-1 align-items-center" href="mailto:pmseldeco@rediffmail.com">
                    <MdMail size={'18'} />
                    pmseldeco@rediffmail.com
                  </a>
                </div>
                {/* <div className="text-white fs-18">
                  Pioneer Montessori Inter College Lucknow
                </div> */}
                <div className="d-inline-block">
                  <Link className="text-white d-flex gap-1 align-items-center"  onClick={handleWhatsAppClick}>
                    <BsWhatsapp size={'18'} />
                    +91 6387355032
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Header Main */}
      <div className="header-main py-2">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="d-lg-flex align-items-center">
                <Link to={'/'} className="navbar-brand logo">
                  <img src="/logonew.svg" alt="Logo" />
                </Link>                

                {/* Navbar */}
                <nav className="navbar navbar-expand-lg">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleMobileMenu}
                    aria-label="Toggle navigation"
                  >
                    <span>
                      {isMobileMenuOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
                    </span>
                  </button>

                  <div
                    className={`navbar-collapse justify-content-end ${
                      isMobileMenuOpen ? "d-block" : "d-none d-lg-block"
                    }`}
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav">
                      {menuItems.map((item, index) => (
                        <li
                          key={index}
                          className={`nav-item ${item.subMenu ? "dropdown" : ""}`}
                        >
                          {/* Main Menu Item */}
                          <Link
                            className={`nav-link ${item.subMenu ? "dropdown-toggle" : ""}`}
                            to={item.link || "#"}
                            onClick={() => item.subMenu && toggleDropdown(index)}
                            role={item.subMenu ? "button" : undefined}
                            aria-haspopup={item.subMenu ? "true" : undefined}
                            aria-expanded={item.subMenu && openDropdownIndex === index ? "true" : "false"}
                          >
                            {item.title}{" "}
                            {item.subMenu && <IoChevronDown className="fa-xs" />}
                          </Link>

                          {/* Submenu */}
                          {item.subMenu && (
                            <ul
                              className={`dropdown-menu ${
                                isMobileMenuOpen && openDropdownIndex === index
                                  ? "d-block"
                                  : "d-none d-lg-block"
                              }`}
                            >
                              {item.subMenu.map((sub, subIndex) => (
                                <li key={subIndex}>
                                  <Link
                                    className="dropdown-item"
                                    to={sub.link}
                                    onClick={handleSubmenuClick} // Mobile pe band ho jayega
                                  >
                                    {sub.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderContent;